import { reactive } from 'vue';
import { UAParser } from 'ua-parser-js';

const defaultUserAgent =
    'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_2) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/64.0.3282.39 Safari/537.36';

export default function useDevice() {
    const userAgent = navigator.userAgent || defaultUserAgent;
    const { device, os } = UAParser(userAgent);

    const isMobile = device.is('mobile');
    const isTablet = device.is('tablet');
    const isDesktop = !isMobile && !isTablet;

    const isWindows = os.is('Windows');
    const isMacOS = os.is('macOS');
    const isLinux = os.is('Linux');

    const specialKey = isMacOS ? 'Cmd' : 'Ctrl';
    const specialKeySymbol = isMacOS ? '⌘' : '⌃';

    return reactive({
        userAgent,

        isMobile,
        isTablet,
        isDesktop,

        isWindows,
        isMacOS,
        isLinux,

        specialKey,
        specialKeySymbol,
    });
}
